// src/services/uptimeRobotApi.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const BEARER_TOKEN = 'ur3174229-837aebaa05060c74e1649352';  
const BACKEND_MONITOR_KEY = '801778580';

export const UPTIME_BOT_STATUSSES= {
    UP: "UP",
    DOWN: "DOWN",
    PAUSED: "PAUSED",
}

export const uptimeRobotApi = createApi({
  reducerPath: 'uptimeRobotApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://api.uptimerobot.com/v3/', 
    prepareHeaders: (headers) => {
      headers.set('Authorization', `Bearer ${BEARER_TOKEN}`);
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getMonitors: builder.mutation({
      query: () => ({ url: 'monitors', method: 'GET' }),
      
    }),
    getSpecificMonitorStatus: builder.query({
      query: (monitorId) => ({ url: `monitors/${BACKEND_MONITOR_KEY}`, method: 'GET' }),
      transformResponse: (response) => {
        // https://uptimerobot.com/api/legacy/
        const status = response.status;
        return {
            isPaused: status?.toUpperCase() === UPTIME_BOT_STATUSSES.PAUSED,
            isUp: status?.toUpperCase() === UPTIME_BOT_STATUSSES.UP, 
            isDown: status?.toUpperCase() === UPTIME_BOT_STATUSSES.DOWN,
            rawStatus: status,
        };
      },
    }),
  }),
});

export const {
  useGetMonitorsMutation,
  useGetSpecificMonitorStatusQuery,
} = uptimeRobotApi;
